module.exports = __webpack_public_path__ + "static/img/back-top.5f254f7d.png";